// Product Grid Actions - Quick View, Wishlist, Add to Cart
// DEBUGGED VERSION with console alerts

class ProductGridActions {
  constructor() {
    // console.log('🚀 ProductGridActions initialized');
    this.init();
  }

  init() {
    // console.log('📋 Setting up event listeners...');
    this.setupQuickView();
    this.setupAddToCart();
    this.setupWishlist();
    // console.log('✅ All event listeners set up');
  }

  // Quick View Functionality
  setupQuickView() {
    // console.log('👁️ Setting up Quick View listener');
    
    document.addEventListener('click', (e) => {
      // console.log('🖱️ Document clicked:', e.target);
      
      const quickViewBtn = e.target.closest('.quick-view-btn');
      // console.log('🔍 Quick view button found:', quickViewBtn);
      
      if (quickViewBtn) {
        e.preventDefault();
        // console.log('✋ Default prevented');
        
        const productUrl = quickViewBtn.dataset.productUrl;
        // console.log('🔗 Product URL:', productUrl);
        
        if (!productUrl) {
          // console.error('❌ ERROR: No product URL found in data-product-url attribute');
          alert('Error: Product URL not found');
          return;
        }
        
        this.openQuickView(productUrl);
      }
    });
  }

  async openQuickView(productUrl) {
    // console.log('📂 Opening quick view for:', productUrl);
    
    try {
      // console.log('🌐 Fetching product data...');
      const response = await fetch(`${productUrl}?view=quick`);
      // console.log('📡 Response status:', response.status);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const html = await response.text();
      // console.log('📄 HTML received, length:', html.length);
      
      // Parse HTML and remove header/footer
      // console.log('🔧 Parsing HTML to remove header/footer...');
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Remove header and footer elements
      const header = doc.querySelector('header, .header, [role="banner"]');
      const footer = doc.querySelector('footer, .footer, [role="contentinfo"]');
      
      if (header) {
        // console.log('🗑️ Header found and removed');
        header.remove();
      } else {
        // console.log('ℹ️ No header found');
      }
      
      if (footer) {
        // console.log('🗑️ Footer found and removed');
        footer.remove();
      } else {
        // console.log('ℹ️ No footer found');
      }
      
      // Get the cleaned body content
      const cleanedHTML = doc.body.innerHTML;
      console.log('✨ Cleaned HTML length:', cleanedHTML.length);
      
      // Create modal
      const modal = document.createElement('div');
      modal.className = 'product-quick-view-modal';
      modal.innerHTML = `
        <div class="quick-view-overlay"></div>
        <div class="quick-view-content">
          <button class="quick-view-close">&times;</button>
          <div class="quick-view-inner">
            ${cleanedHTML}
          </div>
        </div>
      `;
      
      // console.log('🎨 Modal created, appending to body...');
      document.body.appendChild(modal);
      document.body.style.overflow = 'hidden';
      // console.log('✅ Modal appended and visible');
      
      // Trigger animation
      setTimeout(() => {
        modal.style.opacity = '1';
      }, 10);
      
      // Close handlers
      modal.querySelector('.quick-view-close').addEventListener('click', () => {
        // console.log('❌ Close button clicked');
        this.closeQuickView(modal);
      });
      
      modal.querySelector('.quick-view-overlay').addEventListener('click', () => {
        // console.log('❌ Overlay clicked');
        this.closeQuickView(modal);
      });
      
    } catch (error) {
      console.error('💥 Quick view error:', error);
      alert(`Quick View Error: ${error.message}`);
      // Fallback to product page
      // console.log('↩️ Redirecting to product page...');
      window.location.href = productUrl;
    }
  }

  closeQuickView(modal) {
    // console.log('🚪 Closing modal...');
    modal.style.opacity = '0';
    setTimeout(() => {
      modal.remove();
      document.body.style.overflow = '';
      // console.log('✅ Modal removed');
    }, 300);
  }

  // Add to Cart Functionality
  setupAddToCart() {
    // console.log('🛒 Setting up Add to Cart listener');
    
    document.addEventListener('click', async (e) => {
      const addToCartBtn = e.target.closest('.add-to-cart-btn');
      
      if (addToCartBtn) {
        e.preventDefault();
        // console.log('🛒 Add to cart clicked');
        
        const variantId = addToCartBtn.dataset.productId;
        // console.log('🆔 Variant ID:', variantId);
        
        if (!variantId) {
          // console.error('❌ ERROR: No variant ID found');
          alert('Error: Product ID not found');
          return;
        }
        
        await this.addToCart(variantId, addToCartBtn);
      }
    });
  }

  async addToCart(variantId, button) {
    // console.log('➕ Adding to cart:', variantId);
    
    const originalHTML = button.innerHTML;
    button.disabled = true;
    button.innerHTML = `
      <svg class="spinner" width="20" height="20" viewBox="0 0 20 20">
        <circle cx="10" cy="10" r="8" stroke="currentColor" stroke-width="2" fill="none" opacity="0.3"/>
        <path d="M10 2 A 8 8 0 0 1 18 10" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/>
      </svg>
    `;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      // console.log('🛒 Cart response status:', response.status);

      if (response.ok) {
        // console.log('✅ Item added to cart');
        
        // Success feedback
        button.innerHTML = `
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M4 10l4 4 8-8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        `;
        
        // Update cart count if exists
        this.updateCartCount();
        
        // Reset button after 2 seconds
        setTimeout(() => {
          button.innerHTML = originalHTML;
          button.disabled = false;
        }, 2000);
        
      } else {
        throw new Error('Failed to add to cart');
      }
    } catch (error) {
      // console.error('💥 Add to cart error:', error);
      button.innerHTML = originalHTML;
      button.disabled = false;
      alert('Could not add item to cart. Please try again.');
    }
  }

  async updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      // console.log('🛒 Cart count updated:', cart.item_count);
      
      const cartCountElements = document.querySelectorAll('.cart-count, [data-cart-count]');
      cartCountElements.forEach(el => {
        el.textContent = cart.item_count;
      });
    } catch (error) {
      // console.error('💥 Update cart count error:', error);
    }
  }

  // Wishlist Functionality
  setupWishlist() {
    // console.log('❤️ Setting up Wishlist listener');
    
    document.addEventListener('click', (e) => {
      const wishlistBtn = e.target.closest('.wishlist-btn');
      
      if (wishlistBtn) {
        e.preventDefault();
        // console.log('❤️ Wishlist clicked');
        this.toggleWishlist(wishlistBtn);
      }
    });
  }

  toggleWishlist(button) {
    const isActive = button.classList.contains('active');
    // console.log('❤️ Wishlist toggle:', isActive ? 'removing' : 'adding');
    
    if (isActive) {
      button.classList.remove('active');
      button.innerHTML = `
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M10 17.5s-7-4-7-9.5c0-2.5 1.5-4 3.5-4 1.5 0 2.8.8 3.5 2 .7-1.2 2-2 3.5-2 2 0 3.5 1.5 3.5 4 0 5.5-7 9.5-7 9.5z" stroke="currentColor" stroke-width="1.5"/>
        </svg>
      `;
    } else {
      button.classList.add('active');
      button.innerHTML = `
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <path d="M10 17.5s-7-4-7-9.5c0-2.5 1.5-4 3.5-4 1.5 0 2.8.8 3.5 2 .7-1.2 2-2 3.5-2 2 0 3.5 1.5 3.5 4 0 5.5-7 9.5-7 9.5z"/>
        </svg>
      `;
    }
    
    console.log('✅ Wishlist state updated');
  }
}

// Initialize when DOM is ready
// console.log('🔄 Script loaded, waiting for DOM...');

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    // console.log('📄 DOM Content Loaded');
    new ProductGridActions();
  });
} else {
  // console.log('📄 DOM already loaded');
  new ProductGridActions();
}